import locale from 'modules/checkout/presentation/locale';
import routes from 'modules/checkout/presentation/routes';

const checkoutModule = {
  locale,
  routes,
};

export default checkoutModule;
